import React from 'react';

const ImageList = ({ images, selectedImage, onSelectImage, onDeleteImage }) => {
  return (
    <div className="image-list mt-4">
      <h5 className="mb-3">Captured Images</h5>
      <div className="row row-cols-2 row-cols-md-3 g-3">
        {images.map((image, index) => (
          <div key={index} className="col">
            <div 
              className={`card h-100 ${selectedImage === index ? 'border-primary' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              <img 
                src={image} 
                className="card-img-top"
                alt={`Captured ${index}`}
                style={{ height: '120px', objectFit: 'cover' }}
                onClick={() => onSelectImage(index)}
              />
              <div className="card-body p-2">
                <button
                  className="btn btn-danger btn-sm w-100"
                  onClick={() => onDeleteImage(index)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageList;